"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    root: {
      padding: 0,
      margin: 0
    }
  };
}, {
  name: 'AppMenu'
});
exports.useStyles = useStyles;